const state = () => ({
    expanded: true,
});

const getters = {
};

const actions = {
    toggleSidebar({ state, commit }) {
        commit('setExpanded', !state.expanded);
    },
    collapseSidebar({ commit }) {
        commit('setExpanded', false);
    },
    expandSidebar({ commit }) {
        commit('setExpanded', true);
    },
};

const mutations = {
    setExpanded(state, expanded) {
        state.expanded = expanded;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};